import { render, staticRenderFns } from "./Footer4Demo.vue?vue&type=template&id=a51a1b02&"
import script from "./Footer4Demo.vue?vue&type=script&lang=js&"
export * from "./Footer4Demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports